export const   COUNTRY_CODES = {
  NO: "NO",
  ZA: "ZA",
  US: "US",
  FI: "FI"
};

const activeCountry = import.meta.env.VITE_COUNTRY; // direct access, avoids circular import

export const LanguageOptions =
  activeCountry === COUNTRY_CODES.US
    ? [
        { code: "en", name: "English" },
      ]
    : [
        { code: "en", name: "English" },
        { code: "nb", name: "Norsk" },
        { code: "fi", name: "Finnish" },
      ];


export const countries = [

  {
    name: "Afghanistan",
    code: "af",
    flag: "🇦🇫",
    cellAreaCode: "+93"
  },
  {
    name: "Albania",
    code: "al",
    flag: "🇦🇱",
    cellAreaCode: "+355"
  },
  {
    name: "Algeria",
    code: "dz",
    flag: "🇩🇿",
    cellAreaCode: "+213"
  },
  {
    name: "American Samoa",
    code: "as",
    flag: "🇦🇸",
    cellAreaCode: "+1684"
  },
  {
    name: "Andorra",
    code: "ad",
    flag: "🇦🇩",
    cellAreaCode: "+376"
  },
  {
    name: "Angola",
    code: "ao",
    flag: "🇦🇴",
    cellAreaCode: "+244"
  },
  {
    name: "Anguilla",
    code: "ai",
    flag: "🇦🇮",
    cellAreaCode: "+1264"
  },
  {
    name: "Antigua and Barbuda",
    code: "ag",
    flag: "🇦🇬",
    cellAreaCode: "+1268"
  },
  {
    name: "Argentina",
    code: "ar",
    flag: "🇦🇷",
    cellAreaCode: "+54"
  },
  {
    name: "Armenia",
    code: "am",
    flag: "🇦🇲",
    cellAreaCode: "+374"
  },
  {
    name: "Aruba",
    code: "aw",
    flag: "🇦🇼",
    cellAreaCode: "+297"
  },
  {
    name: "Australia",
    code: "au",
    flag: "🇦🇺",
    cellAreaCode: "+61"
  },
  {
    name: "Austria",
    code: "at",
    flag: "🇦🇹",
    cellAreaCode: "+43"
  },
  {
    name: "Azerbaijan",
    code: "az",
    flag: "🇦🇿",
    cellAreaCode: "+994"
  },
  {
    name: "Bahamas",
    code: "bs",
    flag: "🇧🇸",
    cellAreaCode: "+1242"
  },
  {
    name: "Bahrain",
    code: "bh",
    flag: "🇧🇭",
    cellAreaCode: "+973"
  },
  {
    name: "Bangladesh",
    code: "bd",
    flag: "🇧🇩",
    cellAreaCode: "+880"
  },
  {
    name: "Barbados",
    code: "bb",
    flag: "🇧🇧",
    cellAreaCode: "+1246"
  },
  {
    name: "Belarus",
    code: "by",
    flag: "🇧🇾",
    cellAreaCode: "+375"
  },
  {
    name: "Belgium",
    code: "be",
    flag: "🇧🇪",
    cellAreaCode: "+32"
  },
  {
    name: "Belize",
    code: "bz",
    flag: "🇧🇿",
    cellAreaCode: "+501"
  },
  {
    name: "Benin",
    code: "bj",
    flag: "🇧🇯",
    cellAreaCode: "+229"
  },
  {
    name: "Bermuda",
    code: "bm",
    flag: "🇧🇲",
    cellAreaCode: "+1441"
  },
  {
    name: "Bhutan",
    code: "bt",
    flag: "🇧🇹",
    cellAreaCode: "+975"
  },
  {
    name: "Bolivia",
    code: "bo",
    flag: "🇧🇴",
    cellAreaCode: "+591"
  },
  {
    name: "Bosnia and Herzegovina",
    code: "ba",
    flag: "🇧🇦",
    cellAreaCode: "+387"
  },
  {
    name: "Botswana",
    code: "bw",
    flag: "🇧🇼",
    cellAreaCode: "+267"
  },
  {
    name: "Bouvet Island",
    code: "bv",
    flag: "🇧🇻",
    cellAreaCode: "+47"
  },
  {
    name: "Brazil",
    code: "br",
    flag: "🇧🇷",
    cellAreaCode: "+55"
  },
  {
    name: "British Indian Ocean Territory",
    code: "io",
    flag: "🇮🇴",
    cellAreaCode: "+246"
  },
  {
    name: "British Virgin Islands",
    code: "vg",
    flag: "🇻🇬",
    cellAreaCode: "+1284"
  },
  {
    name: "Brunei",
    code: "bn",
    flag: "🇧🇳",
    cellAreaCode: "+673"
  },
  {
    name: "Bulgaria",
    code: "bg",
    flag: "🇧🇬",
    cellAreaCode: "+359"
  },
  {
    name: "Burkina Faso",
    code: "bf",
    flag: "🇧🇫",
    cellAreaCode: "+226"
  },
  {
    name: "Burundi",
    code: "bi",
    flag: "🇧🇮",
    cellAreaCode: "+257"
  },
  {
    name: "Cambodia",
    code: "kh",
    flag: "🇰🇭",
    cellAreaCode: "+855"
  },
  {
    name: "Cameroon",
    code: "cm",
    flag: "🇨🇲",
    cellAreaCode: "+237"
  },
  {
    name: "Canada",
    code: "ca",
    flag: "🇨🇦",
    cellAreaCode: "+1"
  },
  {
    name: "Cape Verde",
    code: "cv",
    flag: "🇨🇻",
    cellAreaCode: "+238"
  },
  {
    name: "Caribbean Netherlands",
    code: "bq",
    flag: "🇧🇶",
    cellAreaCode: "+599"
  },
  {
    name: "Cayman Islands",
    code: "ky",
    flag: "🇰🇾",
    cellAreaCode: "+1345"
  },
  {
    name: "Central African Republic",
    code: "cf",
    flag: "🇨🇫",
    cellAreaCode: "+236"
  },
  {
    name: "Chad",
    code: "td",
    flag: "🇹🇩",
    cellAreaCode: "+235"
  },
  {
    name: "Chile",
    code: "cl",
    flag: "🇨🇱",
    cellAreaCode: "+56"
  },
  {
    name: "China",
    code: "cn",
    flag: "🇨🇳",
    cellAreaCode: "+86"
  },
  {
    name: "Christmas Island",
    code: "cx",
    flag: "🇨🇽",
    cellAreaCode: "+61"
  },
  {
    name: "Cocos (Keeling) Islands",
    code: "cc",
    flag: "🇨🇨",
    cellAreaCode: "+61"
  },
  {
    name: "Colombia",
    code: "co",
    flag: "🇨🇴",
    cellAreaCode: "+57"
  },
  {
    name: "Comoros",
    code: "km",
    flag: "🇰🇲",
    cellAreaCode: "+269"
  },
  {
    name: "Cook Islands",
    code: "ck",
    flag: "🇨🇰",
    cellAreaCode: "+682"
  },
  {
    name: "Costa Rica",
    code: "cr",
    flag: "🇨🇷",
    cellAreaCode: "+506"
  },
  {
    name: "Croatia",
    code: "hr",
    flag: "🇭🇷",
    cellAreaCode: "+385"
  },
  {
    name: "Cuba",
    code: "cu",
    flag: "🇨🇺",
    cellAreaCode: "+53"
  },
  {
    name: "Curaçao",
    code: "cw",
    flag: "🇨🇼",
    cellAreaCode: "+599"
  },
  {
    name: "Cyprus",
    code: "cy",
    flag: "🇨🇾",
    cellAreaCode: "+357"
  },
  {
    name: "Czechia",
    code: "cz",
    flag: "🇨🇿",
    cellAreaCode: "+420"
  },
  {
    name: "Denmark",
    code: "dk",
    flag: "🇩🇰",
    cellAreaCode: "+45"
  },
  {
    name: "Djibouti",
    code: "dj",
    flag: "🇩🇯",
    cellAreaCode: "+253"
  },
  {
    name: "Dominica",
    code: "dm",
    flag: "🇩🇲",
    cellAreaCode: "+1767"
  },
  {
    name: "Dominican Republic",
    code: "do",
    flag: "🇩🇴",
    cellAreaCode: "+829"
  },
  {
    name: "DR Congo",
    code: "cd",
    flag: "🇨🇩",
    cellAreaCode: "+243"
  },
  {
    name: "Ecuador",
    code: "ec",
    flag: "🇪🇨",
    cellAreaCode: "+593"
  },
  {
    name: "Egypt",
    code: "eg",
    flag: "🇪🇬",
    cellAreaCode: "+20"
  },
  {
    name: "El Salvador",
    code: "sv",
    flag: "🇸🇻",
    cellAreaCode: "+503"
  },
  {
    name: "Equatorial Guinea",
    code: "gq",
    flag: "🇬🇶",
    cellAreaCode: "+240"
  },
  {
    name: "Eritrea",
    code: "er",
    flag: "🇪🇷",
    cellAreaCode: "+291"
  },
  {
    name: "Estonia",
    code: "ee",
    flag: "🇪🇪",
    cellAreaCode: "+372"
  },
  {
    name: "Eswatini",
    code: "sz",
    flag: "🇸🇿",
    cellAreaCode: "+268"
  },
  {
    name: "Ethiopia",
    code: "et",
    flag: "🇪🇹",
    cellAreaCode: "+251"
  },
  {
    name: "Falkland Islands",
    code: "fk",
    flag: "🇫🇰",
    cellAreaCode: "+500"
  },
  {
    name: "Faroe Islands",
    code: "fo",
    flag: "🇫🇴",
    cellAreaCode: "+298"
  },
  {
    name: "Fiji",
    code: "fj",
    flag: "🇫🇯",
    cellAreaCode: "+679"
  },
  {
    name: "Finland",
    code: "fi",
    flag: "🇫🇮",
    cellAreaCode: "+358"
  },
  {
    name: "France",
    code: "fr",
    flag: "🇫🇷",
    cellAreaCode: "+33"
  },
  {
    name: "French Guiana",
    code: "gf",
    flag: "🇬🇫",
    cellAreaCode: "+594"
  },
  {
    name: "French Polynesia",
    code: "pf",
    flag: "🇵🇫",
    cellAreaCode: "+689"
  },
  {
    name: "French Southern and Antarctic Lands",
    code: "tf",
    flag: "🇹🇫",
    cellAreaCode: "+262"
  },
  {
    name: "Gabon",
    code: "ga",
    flag: "🇬🇦",
    cellAreaCode: "+241"
  },
  {
    name: "Gambia",
    code: "gm",
    flag: "🇬🇲",
    cellAreaCode: "+220"
  },
  {
    name: "Georgia",
    code: "ge",
    flag: "🇬🇪",
    cellAreaCode: "+995"
  },
  {
    name: "Germany",
    code: "de",
    flag: "🇩🇪",
    cellAreaCode: "+49"
  },
  {
    name: "Ghana",
    code: "gh",
    flag: "🇬🇭",
    cellAreaCode: "+233"
  },
  {
    name: "Gibraltar",
    code: "gi",
    flag: "🇬🇮",
    cellAreaCode: "+350"
  },
  {
    name: "Greece",
    code: "gr",
    flag: "🇬🇷",
    cellAreaCode: "+30"
  },
  {
    name: "Greenland",
    code: "gl",
    flag: "🇬🇱",
    cellAreaCode: "+299"
  },
  {
    name: "Grenada",
    code: "gd",
    flag: "🇬🇩",
    cellAreaCode: "+1473"
  },
  {
    name: "Guadeloupe",
    code: "gp",
    flag: "🇬🇵",
    cellAreaCode: "+590"
  },
  {
    name: "Guam",
    code: "gu",
    flag: "🇬🇺",
    cellAreaCode: "+1671"
  },
  {
    name: "Guatemala",
    code: "gt",
    flag: "🇬🇹",
    cellAreaCode: "+502"
  },
  {
    name: "Guernsey",
    code: "gg",
    flag: "🇬🇬",
    cellAreaCode: "+44"
  },
  {
    name: "Guinea",
    code: "gn",
    flag: "🇬🇳",
    cellAreaCode: "+224"
  },
  {
    name: "Guinea-Bissau",
    code: "gw",
    flag: "🇬🇼",
    cellAreaCode: "+245"
  },
  {
    name: "Guyana",
    code: "gy",
    flag: "🇬🇾",
    cellAreaCode: "+592"
  },
  {
    name: "Haiti",
    code: "ht",
    flag: "🇭🇹",
    cellAreaCode: "+509"
  },
  {
    name: "Heard Island and McDonald Islands",
    code: "hm",
    flag: "🇭🇲",
    cellAreaCode: null
  },
  {
    name: "Honduras",
    code: "hn",
    flag: "🇭🇳",
    cellAreaCode: "+504"
  },
  {
    name: "Hong Kong",
    code: "hk",
    flag: "🇭🇰",
    cellAreaCode: "+852"
  },
  {
    name: "Hungary",
    code: "hu",
    flag: "🇭🇺",
    cellAreaCode: "+36"
  },
  {
    name: "Iceland",
    code: "is",
    flag: "🇮🇸",
    cellAreaCode: "+354"
  },
  {
    name: "India",
    code: "in",
    flag: "🇮🇳",
    cellAreaCode: "+91"
  },
  {
    name: "Indonesia",
    code: "id",
    flag: "🇮🇩",
    cellAreaCode: "+62"
  },
  {
    name: "Iran",
    code: "ir",
    flag: "🇮🇷",
    cellAreaCode: "+98"
  },
  {
    name: "Iraq",
    code: "iq",
    flag: "🇮🇶",
    cellAreaCode: "+964"
  },
  {
    name: "Ireland",
    code: "ie",
    flag: "🇮🇪",
    cellAreaCode: "+353"
  },
  {
    name: "Isle of Man",
    code: "im",
    flag: "🇮🇲",
    cellAreaCode: "+44"
  },
  {
    name: "Israel",
    code: "il",
    flag: "🇮🇱",
    cellAreaCode: "+972"
  },
  {
    name: "Italy",
    code: "it",
    flag: "🇮🇹",
    cellAreaCode: "+39"
  },
  {
    name: "Ivory Coast",
    code: "ci",
    flag: "🇨🇮",
    cellAreaCode: "+225"
  },
  {
    name: "Jamaica",
    code: "jm",
    flag: "🇯🇲",
    cellAreaCode: "+1876"
  },
  {
    name: "Japan",
    code: "jp",
    flag: "🇯🇵",
    cellAreaCode: "+81"
  },
  {
    name: "Jersey",
    code: "je",
    flag: "🇯🇪",
    cellAreaCode: "+44"
  },
  {
    name: "Jordan",
    code: "jo",
    flag: "🇯🇴",
    cellAreaCode: "+962"
  },
  {
    name: "Kazakhstan",
    code: "kz",
    flag: "🇰🇿",
    cellAreaCode: "+7"
  },
  {
    name: "Kenya",
    code: "ke",
    flag: "🇰🇪",
    cellAreaCode: "+254"
  },
  {
    name: "Kiribati",
    code: "ki",
    flag: "🇰🇮",
    cellAreaCode: "+686"
  },
  {
    name: "Kosovo",
    code: "xk",
    flag: "🇽🇰",
    cellAreaCode: "+383"
  },
  {
    name: "Kuwait",
    code: "kw",
    flag: "🇰🇼",
    cellAreaCode: "+965"
  },
  {
    name: "Kyrgyzstan",
    code: "kg",
    flag: "🇰🇬",
    cellAreaCode: "+996"
  },
  {
    name: "Laos",
    code: "la",
    flag: "🇱🇦",
    cellAreaCode: "+856"
  },
  {
    name: "Latvia",
    code: "lv",
    flag: "🇱🇻",
    cellAreaCode: "+371"
  },
  {
    name: "Lebanon",
    code: "lb",
    flag: "🇱🇧",
    cellAreaCode: "+961"
  },
  {
    name: "Lesotho",
    code: "ls",
    flag: "🇱🇸",
    cellAreaCode: "+266"
  },
  {
    name: "Liberia",
    code: "lr",
    flag: "🇱🇷",
    cellAreaCode: "+231"
  },
  {
    name: "Libya",
    code: "ly",
    flag: "🇱🇾",
    cellAreaCode: "+218"
  },
  {
    name: "Liechtenstein",
    code: "li",
    flag: "🇱🇮",
    cellAreaCode: "+423"
  },
  {
    name: "Lithuania",
    code: "lt",
    flag: "🇱🇹",
    cellAreaCode: "+370"
  },
  {
    name: "Luxembourg",
    code: "lu",
    flag: "🇱🇺",
    cellAreaCode: "+352"
  },
  {
    name: "Macau",
    code: "mo",
    flag: "🇲🇴",
    cellAreaCode: "+853"
  },
  {
    name: "Madagascar",
    code: "mg",
    flag: "🇲🇬",
    cellAreaCode: "+261"
  },
  {
    name: "Malawi",
    code: "mw",
    flag: "🇲🇼",
    cellAreaCode: "+265"
  },
  {
    name: "Malaysia",
    code: "my",
    flag: "🇲🇾",
    cellAreaCode: "+60"
  },
  {
    name: "Maldives",
    code: "mv",
    flag: "🇲🇻",
    cellAreaCode: "+960"
  },
  {
    name: "Mali",
    code: "ml",
    flag: "🇲🇱",
    cellAreaCode: "+223"
  },
  {
    name: "Malta",
    code: "mt",
    flag: "🇲🇹",
    cellAreaCode: "+356"
  },
  {
    name: "Marshall Islands",
    code: "mh",
    flag: "🇲🇭",
    cellAreaCode: "+692"
  },
  {
    name: "Martinique",
    code: "mq",
    flag: "🇲🇶",
    cellAreaCode: "+596"
  },
  {
    name: "Mauritania",
    code: "mr",
    flag: "🇲🇷",
    cellAreaCode: "+222"
  },
  {
    name: "Mauritius",
    code: "mu",
    flag: "🇲🇺",
    cellAreaCode: "+230"
  },
  {
    name: "Mayotte",
    code: "yt",
    flag: "🇾🇹",
    cellAreaCode: "+262"
  },
  {
    name: "Mexico",
    code: "mx",
    flag: "🇲🇽",
    cellAreaCode: "+52"
  },
  {
    name: "Micronesia",
    code: "fm",
    flag: "🇫🇲",
    cellAreaCode: "+691"
  },
  {
    name: "Moldova",
    code: "md",
    flag: "🇲🇩",
    cellAreaCode: "+373"
  },
  {
    name: "Monaco",
    code: "mc",
    flag: "🇲🇨",
    cellAreaCode: "+377"
  },
  {
    name: "Mongolia",
    code: "mn",
    flag: "🇲🇳",
    cellAreaCode: "+976"
  },
  {
    name: "Montenegro",
    code: "me",
    flag: "🇲🇪",
    cellAreaCode: "+382"
  },
  {
    name: "Montserrat",
    code: "ms",
    flag: "🇲🇸",
    cellAreaCode: "+1664"
  },
  {
    name: "Morocco",
    code: "ma",
    flag: "🇲🇦",
    cellAreaCode: "+212"
  },
  {
    name: "Mozambique",
    code: "mz",
    flag: "🇲🇿",
    cellAreaCode: "+258"
  },
  {
    name: "Myanmar",
    code: "mm",
    flag: "🇲🇲",
    cellAreaCode: "+95"
  },
  {
    name: "Namibia",
    code: "na",
    flag: "🇳🇦",
    cellAreaCode: "+264"
  },
  {
    name: "Nauru",
    code: "nr",
    flag: "🇳🇷",
    cellAreaCode: "+674"
  },
  {
    name: "Nepal",
    code: "np",
    flag: "🇳🇵",
    cellAreaCode: "+977"
  },
  {
    name: "Netherlands",
    code: "nl",
    flag: "🇳🇱",
    cellAreaCode: "+31"
  },
  {
    name: "New Caledonia",
    code: "nc",
    flag: "🇳🇨",
    cellAreaCode: "+687"
  },
  {
    name: "New Zealand",
    code: "nz",
    flag: "🇳🇿",
    cellAreaCode: "+64"
  },
  {
    name: "Nicaragua",
    code: "ni",
    flag: "🇳🇮",
    cellAreaCode: "+505"
  },
  {
    name: "Niger",
    code: "ne",
    flag: "🇳🇪",
    cellAreaCode: "+227"
  },
  {
    name: "Nigeria",
    code: "ng",
    flag: "🇳🇬",
    cellAreaCode: "+234"
  },
  {
    name: "Niue",
    code: "nu",
    flag: "🇳🇺",
    cellAreaCode: "+683"
  },
  {
    name: "Norfolk Island",
    code: "nf",
    flag: "🇳🇫",
    cellAreaCode: "+672"
  },
  {
    name: "North Korea",
    code: "kp",
    flag: "🇰🇵",
    cellAreaCode: "+850"
  },
  {
    name: "North Macedonia",
    code: "mk",
    flag: "🇲🇰",
    cellAreaCode: "+389"
  },
  {
    name: "Northern Mariana Islands",
    code: "mp",
    flag: "🇲🇵",
    cellAreaCode: "+1670"
  },
  {
    name: "Norway",
    code: "no",
    flag: "🇳🇴",
    cellAreaCode: "+47"
  },
  {
    name: "Oman",
    code: "om",
    flag: "🇴🇲",
    cellAreaCode: "+968"
  },
  {
    name: "Pakistan",
    code: "pk",
    flag: "🇵🇰",
    cellAreaCode: "+92"
  },
  {
    name: "Palau",
    code: "pw",
    flag: "🇵🇼",
    cellAreaCode: "+680"
  },
  {
    name: "Palestine",
    code: "ps",
    flag: "🇵🇸",
    cellAreaCode: "+970"
  },
  {
    name: "Panama",
    code: "pa",
    flag: "🇵🇦",
    cellAreaCode: "+507"
  },
  {
    name: "Papua New Guinea",
    code: "pg",
    flag: "🇵🇬",
    cellAreaCode: "+675"
  },
  {
    name: "Paraguay",
    code: "py",
    flag: "🇵🇾",
    cellAreaCode: "+595"
  },
  {
    name: "Peru",
    code: "pe",
    flag: "🇵🇪",
    cellAreaCode: "+51"
  },
  {
    name: "Philippines",
    code: "ph",
    flag: "🇵🇭",
    cellAreaCode: "+63"
  },
  {
    name: "Pitcairn Islands",
    code: "pn",
    flag: "🇵🇳",
    cellAreaCode: "+64"
  },
  {
    name: "Poland",
    code: "pl",
    flag: "🇵🇱",
    cellAreaCode: "+48"
  },
  {
    name: "Portugal",
    code: "pt",
    flag: "🇵🇹",
    cellAreaCode: "+351"
  },
  {
    name: "Puerto Rico",
    code: "pr",
    flag: "🇵🇷",
    cellAreaCode: "+1787,939"
  },
  {
    name: "Qatar",
    code: "qa",
    flag: "🇶🇦",
    cellAreaCode: "+974"
  },
  {
    name: "Republic of the Congo",
    code: "cg",
    flag: "🇨🇬",
    cellAreaCode: "+242"
  },
  {
    name: "Romania",
    code: "ro",
    flag: "🇷🇴",
    cellAreaCode: "+40"
  },
  {
    name: "Russia",
    code: "ru",
    flag: "🇷🇺",
    cellAreaCode: "+7"
  },
  {
    name: "Rwanda",
    code: "rw",
    flag: "🇷🇼",
    cellAreaCode: "+250"
  },
  {
    name: "Réunion",
    code: "re",
    flag: "🇷🇪",
    cellAreaCode: "+262"
  },
  {
    name: "Saint Barthélemy",
    code: "bl",
    flag: "🇧🇱",
    cellAreaCode: "+590"
  },
  {
    name: "Saint Kitts and Nevis",
    code: "kn",
    flag: "🇰🇳",
    cellAreaCode: "+1869"
  },
  {
    name: "Saint Lucia",
    code: "lc",
    flag: "🇱🇨",
    cellAreaCode: "+1758"
  },
  {
    name: "Saint Martin",
    code: "mf",
    flag: "🇲🇫",
    cellAreaCode: "+590"
  },
  {
    name: "Saint Pierre and Miquelon",
    code: "pm",
    flag: "🇵🇲",
    cellAreaCode: "+508"
  },
  {
    name: "Saint Vincent and the Grenadines",
    code: "vc",
    flag: "🇻🇨",
    cellAreaCode: "+1784"
  },
  {
    name: "Samoa",
    code: "ws",
    flag: "🇼🇸",
    cellAreaCode: "+685"
  },
  {
    name: "San Marino",
    code: "sm",
    flag: "🇸🇲",
    cellAreaCode: "+378"
  },
  {
    name: "Saudi Arabia",
    code: "sa",
    flag: "🇸🇦",
    cellAreaCode: "+966"
  },
  {
    name: "Senegal",
    code: "sn",
    flag: "🇸🇳",
    cellAreaCode: "+221"
  },
  {
    name: "Serbia",
    code: "rs",
    flag: "🇷🇸",
    cellAreaCode: "+381"
  },
  {
    name: "Seychelles",
    code: "sc",
    flag: "🇸🇨",
    cellAreaCode: "+248"
  },
  {
    name: "Sierra Leone",
    code: "sl",
    flag: "🇸🇱",
    cellAreaCode: "+232"
  },
  {
    name: "Singapore",
    code: "sg",
    flag: "🇸🇬",
    cellAreaCode: "+65"
  },
  {
    name: "Sint Maarten",
    code: "sx",
    flag: "🇸🇽",
    cellAreaCode: "+1721"
  },
  {
    name: "Slovakia",
    code: "sk",
    flag: "🇸🇰",
    cellAreaCode: "+421"
  },
  {
    name: "Slovenia",
    code: "si",
    flag: "🇸🇮",
    cellAreaCode: "+386"
  },
  {
    name: "Solomon Islands",
    code: "sb",
    flag: "🇸🇧",
    cellAreaCode: "+677"
  },
  {
    name: "Somalia",
    code: "so",
    flag: "🇸🇴",
    cellAreaCode: "+252"
  },
  {
    name: "South Africa",
    code: "za",
    flag: "🇿🇦",
    cellAreaCode: "+27"
  },
  {
    name: "South Georgia",
    code: "gs",
    flag: "🇬🇸",
    cellAreaCode: "+500"
  },
  {
    name: "South Korea",
    code: "kr",
    flag: "🇰🇷",
    cellAreaCode: "+82"
  },
  {
    name: "South Sudan",
    code: "ss",
    flag: "🇸🇸",
    cellAreaCode: "+211"
  },
  {
    name: "Spain",
    code: "es",
    flag: "🇪🇸",
    cellAreaCode: "+34"
  },
  {
    name: "Sri Lanka",
    code: "lk",
    flag: "🇱🇰",
    cellAreaCode: "+94"
  },
  {
    name: "Sudan",
    code: "sd",
    flag: "🇸🇩",
    cellAreaCode: "+249"
  },
  {
    name: "Suriname",
    code: "sr",
    flag: "🇸🇷",
    cellAreaCode: "+597"
  },
  {
    name: "Svalbard and Jan Mayen",
    code: "sj",
    flag: "🇸🇯",
    cellAreaCode: "+4779"
  },
  {
    name: "Sweden",
    code: "se",
    flag: "🇸🇪",
    cellAreaCode: "+46"
  },
  {
    name: "Switzerland",
    code: "ch",
    flag: "🇨🇭",
    cellAreaCode: "+41"
  },
  {
    name: "Syria",
    code: "sy",
    flag: "🇸🇾",
    cellAreaCode: "+963"
  },
  {
    name: "São Tomé and Príncipe",
    code: "st",
    flag: "🇸🇹",
    cellAreaCode: "+239"
  },
  {
    name: "Taiwan",
    code: "tw",
    flag: "🇹🇼",
    cellAreaCode: "+886"
  },
  {
    name: "Tajikistan",
    code: "tj",
    flag: "🇹🇯",
    cellAreaCode: "+992"
  },
  {
    name: "Tanzania",
    code: "tz",
    flag: "🇹🇿",
    cellAreaCode: "+255"
  },
  {
    name: "Thailand",
    code: "th",
    flag: "🇹🇭",
    cellAreaCode: "+66"
  },
  {
    name: "Timor-Leste",
    code: "tl",
    flag: "🇹🇱",
    cellAreaCode: "+670"
  },
  {
    name: "Togo",
    code: "tg",
    flag: "🇹🇬",
    cellAreaCode: "+228"
  },
  {
    name: "Tokelau",
    code: "tk",
    flag: "🇹🇰",
    cellAreaCode: "+690"
  },
  {
    name: "Tonga",
    code: "to",
    flag: "🇹🇴",
    cellAreaCode: "+676"
  },
  {
    name: "Trinidad and Tobago",
    code: "tt",
    flag: "🇹🇹",
    cellAreaCode: "+1868"
  },
  {
    name: "Tunisia",
    code: "tn",
    flag: "🇹🇳",
    cellAreaCode: "+216"
  },
  {
    name: "Turkey",
    code: "tr",
    flag: "🇹🇷",
    cellAreaCode: "+90"
  },
  {
    name: "Turkmenistan",
    code: "tm",
    flag: "🇹🇲",
    cellAreaCode: "+993"
  },
  {
    name: "Turks and Caicos Islands",
    code: "tc",
    flag: "🇹🇨",
    cellAreaCode: "+1649"
  },
  {
    name: "Tuvalu",
    code: "tv",
    flag: "🇹🇻",
    cellAreaCode: "+688"
  },
  {
    name: "Uganda",
    code: "ug",
    flag: "🇺🇬",
    cellAreaCode: "+256"
  },
  {
    name: "Ukraine",
    code: "ua",
    flag: "🇺🇦",
    cellAreaCode: "+380"
  },
  {
    name: "United Arab Emirates",
    code: "ae",
    flag: "🇦🇪",
    cellAreaCode: "+971"
  },
  {
    name: "United Kingdom",
    code: "gb",
    flag: "🇬🇧",
    cellAreaCode: "+44"
  },
  {
    name: "United States Minor Outlying Islands",
    code: "um",
    flag: "🇺🇲",
    cellAreaCode: "+268"
  },
  {
    name: "United States Virgin Islands",
    code: "vi",
    flag: "🇻🇮",
    cellAreaCode: "+1340"
  },
  {
    name: "United States of America",
    code: "us",
    flag: "🇺🇸",
    cellAreaCode: "+1"
  },
  {
    name: "Uruguay",
    code: "uy",
    flag: "🇺🇾",
    cellAreaCode: "+598"
  },
  {
    name: "Uzbekistan",
    code: "uz",
    flag: "🇺🇿",
    cellAreaCode: "+998"
  },
  {
    name: "Vanuatu",
    code: "vu",
    flag: "🇻🇺",
    cellAreaCode: "+678"
  },
  {
    name: "Venezuela",
    code: "ve",
    flag: "🇻🇪",
    cellAreaCode: "+58"
  },
  {
    name: "Vietnam",
    code: "vn",
    flag: "🇻🇳",
    cellAreaCode: "+84"
  },
  {
    name: "Wallis and Futuna",
    code: "wf",
    flag: "🇼🇫",
    cellAreaCode: "+681"
  },
  {
    name: "Yemen",
    code: "ye",
    flag: "🇾🇪",
    cellAreaCode: "+967"
  },
  {
    name: "Zambia",
    code: "zm",
    flag: "🇿🇲",
    cellAreaCode: "+260"
  },
  {
    name: "Zimbabwe",
    code: "zw",
    flag: "🇿🇼",
    cellAreaCode: "+263"
  },
  {
    name: "Åland Islands",
    code: "ax",
    flag: "🇦🇽",
    cellAreaCode: "+35818"
  }

  // {
  //   name: "United States",
  //   code: "us",
  //   flag: "🇺🇸",
  //   cellAreaCode:
  //     "+1201,202,203,205,206,207,208,209,210,212,213,214,215,216,217,218,219,220,224,225,227,228,229,231,234,239,240,248," +
  //     "251,252,253,254,256,260,262,267,269,270,272,274,276,281,283,301,302,303,304,305,307,308,309,310,312,313,314,315,316," +
  //     "317,318,319,320,321,323,325,327,330,331,334,336,337,339,346,347,351,352,360,361,364,380,385,386,401,402,404,405,406," +
  //     "407,408,409,410,412,413,414,415,417,419,423,424,425,430,432,434,435,440,442,443,447,458,463,464,469,470,475,478,479," +
  //     "480,484,501,502,503,504,505,507,508,509,510,512,513,515,516,517,518,520,530,531,534,539,540,541,551,559,561,562,563," +
  //     "564,567,570,571,573,574,575,580,585,586,601,602,603,605,606,607,608,609,610,612,614,615,616,617,618,619,620,623,626," +
  //     "628,629,630,631,636,641,646,650,651,657,660,661,662,667,669,678,681,682,701,702,703,704,706,707,708,712,713,714,715," +
  //     "716,717,718,719,720,724,725,727,730,731,732,734,737,740,743,747,754,757,760,762,763,765,769,770,772,773,774,775,779," +
  //     "781,785,786,801,802,803,804,805,806,808,810,812,813,814,815,816,817,818,828,830,831,832,843,845,847,848,850,854,856," +
  //     "857,858,859,860,862,863,864,865,870,872,878,901,903,904,906,907,908,909,910,912,913,914,915,916,917,918,919,920,925," +
  //     "928,929,930,931,934,936,937,938,940,941,947,949,951,952,954,956,959,970,971,972,973,975,978,979,980,984,985,989",
  // },
  // {
  //   name: "Dev",
  //   code: "bd",
  //   flag: "🇧🇩",
  //   cellAreaCode: "+88",
  // },
];